<template>
  <table class="single-date-picker__calendar-month">
    <thead>
      <CalendarWeekHeader
        v-for="(day, index) in daysInWeek"
        :key="index"
        :day="day"
      />
    </thead>
    <tbody>
      <CalendarWeek
        v-for="(week, index) in datesPerWeek"
        :key="index"
        :week="week"
        :is-today="isToday"
        :is-selected="isSelected"
        @selectDate="selectDate"
        :min-day="minDay"
        :max-day="maxDay"
      />
    </tbody>
  </table>
</template>

<script>
import CalendarWeekHeader from './CalendarWeekHeader';
import CalendarWeek from './CalendarWeek';

export default {
  components: {
    CalendarWeekHeader,
    CalendarWeek
  },
  props: {
    datesPerWeek: {
      type: Array,
      default: () => []
    },
    isToday: {
      type: Number,
      default: 0
    },
    isSelected: {
      type: Number,
      default: 0,
    },
    weekStartDay: {
      type: Number,
      default: 0,
    },
    minDay: {
      type: Number,
      default: () => null
    },
    maxDay: {
      type: Number,
      default: () => null
    },
    lang: {
      type: String,
      default: () => 'ru'
    }
  },
  computed:{
    daysInWeek: function (){
      const daysInWeekLang = {
        "en": ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        "ru": ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      };
      return daysInWeekLang[this.lang];
    }
  },
  created() {
    this.rotateDaysInWeek(this.daysInWeek, this.weekStartDay);
  },
  methods: {
    selectDate(date) {
      this.$emit('selectDate', date);
    },
    rotateDaysInWeek(daysInWeek, shifts) {
      while(shifts--) {
        const temp = daysInWeek.shift();
        daysInWeek.push(temp);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.single-date-picker__calendar-month {
  width: 100%;
}
</style>